import { supabase } from './supabase';
import type { UserProfile, UserProfileMap } from '../types/user';

export async function fetchUserProfiles(): Promise<UserProfileMap> {
  try {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('user_id, display_name');

    if (error) throw error;

    return (data || []).reduce((acc: UserProfileMap, profile) => {
      acc[profile.user_id] = profile.display_name;
      return acc;
    }, {});
  } catch (error) {
    console.error('Error fetching user profiles:', error);
    return {};
  }
}

export async function updateUserProfile(displayName: string): Promise<UserProfile | null> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase
      .from('user_profiles')
      .upsert({
        user_id: user.id,
        display_name: displayName
      }, {
        onConflict: 'user_id'
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    return null;
  }
}